import { useLocation, useNavigate } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
export const GoBack = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const goBack = () => {
    track("goBack: from", location);
    navigate("/home");
  };
  return (
    <button
      style={{
        position: "absolute",
        top: "5px",
        left: "5px",
        backgroundColor: "transparent",
        borderRadius: "50%",
        // border: "1px solid #222",
        fontSize: "1rem",
        color: "#222",
      }}
      onClick={goBack}
    >
      {"< back"}
    </button>
  );
};
